import { render, staticRenderFns } from "./ComponentSettingDialog.vue?vue&type=template&id=b456faae&scoped=true"
import script from "./ComponentSettingDialog.vue?vue&type=script&lang=js"
export * from "./ComponentSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./ComponentSettingDialog.vue?vue&type=style&index=0&id=b456faae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b456faae",
  null
  
)

export default component.exports